(function($, viewport) {

	'use strict'
	
	// NOTE  : dependencies à ajouter > lodash

	var init = function() {
		if (!_.isUndefined(MARKERS) && !_.isEmpty(MARKERS)) {
			initImplantationsMap()
		}
	}
	
	var initImplantationsMap = function() {

		$('section.listing-map').implantations_map({
			theme_path: THEME_PATH,
			world: {lat: parseFloat(WORLD_POSITION.lat), lng: parseFloat(WORLD_POSITION.lng), zoom: parseFloat(WORLD_POSITION.zoom)},
			style: [	
					{	"featureType":"administrative",
						"elementType":"labels.text.fill",
						"stylers":[{"color":"#444444"}]
					},
					{	"featureType":"landscape",
						"elementType":"all",
						"stylers":[{"color":"#f2f2f2"}]
					},
					{	"featureType":"poi",
						"elementType":"all",
						"stylers":[{"visibility":"off"}]
					},
					{	"featureType":"road",
						"elementType":"all",
						"stylers":[{"saturation":-100}, {"lightness":45}]
					},
					{	"featureType":"road.highway",
						"elementType":"all",
						"stylers":[{"visibility":"simplified"}]
					},
					{	"featureType":"road.arterial",
						"elementType":"labels.icon",
						"stylers":[{"visibility":"off"}]
					},
					{	"featureType":"transit",
						"elementType":"all",
						"stylers":[{"visibility":"off"}]
					},
					{	"featureType":"water",
						"elementType":"all",
						"stylers":[{"color":"#3e9fd2"}, {"visibility":"on"}]
					}
				],
			markers: MARKERS,
		});

	}

	$.fn.implantations_map = function(options) {
		if(!options) return

		return this.each(function() {
			var $self = $(this)
			var $map = $self.find('.map')
			var map;

			var create_markers = function(icon_default, icon_selected) {

				// Liste des marqueurs, pour réutilisation (changement icones lors sélection)
				var marker_list = new Array;

				options.markers.forEach(function(marker) {		
					
					var marker_data = marker.map_more_data;
                    
                    var markerLatLng = new google.maps.LatLng(marker.lat, marker.lng);
                    var marker = new google.maps.Marker({
                        position: markerLatLng,
                        title: marker.title,
                        icon: icon_default,
                    });	
					marker.setMap(map);

					// Affichage de la popup "Informations supplémentaires"
					// Lors du clic sur un marqueur
					marker.addListener('click', () => {
						var $popup_list = $('.map-more');
						var $popup_more = $('#' + marker.title);

						$popup_list.removeClass('visible');
						$popup_more.addClass('visible');
					});

					// Ajoute le marqueur à la liste des marqueurs
					marker_list.push(marker);
				})
				
				// Changement de couleur du marqueur lors de la sélection
				marker_list.forEach((marker) => {

					marker.addListener('click', () => {

						// Tous les marqueurs prennent l'icone par défaut (désélectionnée)
						marker_list.forEach((unselected_marker) => {
							unselected_marker.setIcon(icon_default);
						});
						// Le marqueur sélectionné prend l'icône de sélection
						marker.setIcon(icon_selected);
					});
				});

				return marker_list;
            }
            
            var showVisibleMarkers = function() {
				var bounds = map.getBounds();

                options.markers.forEach(function(marker) {

                    var infoPanel = $('.map-infopanel[data-title="' + marker.title + '"]');

                    var markerLatLng = new google.maps.LatLng(marker.lat, marker.lng);
                    var marker = new google.maps.Marker({
                        position: markerLatLng,
                        title: marker.title,
                        //icon: options.theme_path + '/images/marker_map.png'
                    });
                                                       
                    if(bounds.contains(marker.getPosition())===true) {
                        infoPanel.show();
                    }
                    else {
                        infoPanel.hide();
                    }
                })
            }

			var create_gmap = function(default_latlng) {

				// Création icônes personnalisées
				// -- Défaut
				var default_icon = {
					url: options.theme_path + '/images/icon_map_location.svg',
					scaledSize: new google.maps.Size(40, 50),
				};
				// -- Sélectionné
				var selected_icon = {
					url: options.theme_path + '/images/icon_map_location_selected.svg',
					scaledSize: new google.maps.Size(40, 50),
				};

                var mapOptions = {
                    center: new google.maps.LatLng(options.world.lat, options.world.lng),
                    zoom: options.world.zoom,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					// Custom UI
					mapTypeControl: false,
					streetViewControl: false,
					fullscreenControl: false,
					zoomControlOptions: {
						position: google.maps.ControlPosition.TOP_RIGHT,
					},
                };
                
                map = new google.maps.Map($map[0], mapOptions);

                var marker_list = create_markers(default_icon, selected_icon);
                
                // google.maps.event.addListener(map, 'idle', function() {
                //     showVisibleMarkers();
				// });

				// Ferme la popup lors du déplacement de la carte
				var closePopup = function () {
					$('.map-more').removeClass('visible');

					// Tous les marqueurs prennent l'icone par défaut (désélectionnée)
					marker_list.forEach((unselected_marker) => {
						unselected_marker.setIcon(default_icon);
					});
				}
				map.addListener('drag', closePopup);
				map.addListener('click', closePopup);
			}

			$(function() {
				create_gmap()
			})
		})
	}

	$(document).ready(function() {
        if($('body').hasClass('page-template-template-implantations')) {
            init()
        }
	})


})(jQuery)
